import { render } from "./BlockHeader.vue?vue&type=template&id=b4f15a9e&scoped=true"
import script from "./BlockHeader.vue?vue&type=script&lang=js"
export * from "./BlockHeader.vue?vue&type=script&lang=js"

import "./BlockHeader.vue?vue&type=style&index=0&id=b4f15a9e&scoped=true&lang=css"

import exportComponent from "/home/jbenes/PhpstormProjects/VUE/VUE_Neustadt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4f15a9e"]])

export default __exports__